import { takeLatest, put } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { setPartsSelectAction, ISetPartsSelectParam } from '@app/react/action';

function* checkAvailableParts(action: Action<ISetPartsSelectParam>) {
    const { item } = action.payload;

    // TODO: check avariable via backend

    yield put(
        setPartsSelectAction.done({
            params: action.payload,
            result: { item },
        }),
    );
}

export const designSaga = [
    takeLatest(setPartsSelectAction.started.type, checkAvailableParts),
];
